import { render, staticRenderFns } from "./Developing.vue?vue&type=template&id=7d087a50&scoped=true&"
var script = {}
import style0 from "./Developing.vue?vue&type=style&index=0&id=7d087a50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d087a50",
  null
  
)

export default component.exports